import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { HelpCenterAdminPage } from '@/features/help-center/admin'

export const Route = createFileRoute('/_authenticated/admin/help-center/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: HelpCenterAdminPage,
})
